import { HttpContext, HttpContextToken } from '@angular/common/http';

type ContextToken = {
  token: HttpContextToken<any>;
  value: any;
};

export const IS_OFFLINE_FIRST_ENABLED = new HttpContextToken<boolean>(() => false);
export const REFRESH_OFFLINE_FIRST = new HttpContextToken<boolean>(() => false);

export function createHttpContext(...contextTokens: ContextToken[]): HttpContext {
  let context = new HttpContext();
  for (let contextToken of contextTokens) {
    context = context.set(contextToken.token, contextToken.value);
  }
  return context;
}

export function enableOfflineFirst(): HttpContext {
  return createHttpContext(createContextToken(IS_OFFLINE_FIRST_ENABLED, true));
}

export function refreshOfflineFirst(): HttpContext {
  return createHttpContext(createContextToken(REFRESH_OFFLINE_FIRST, true));
}

export function createContextToken<T>(token: HttpContextToken<T>, value: T): ContextToken {
  return {
    token: token,
    value: value,
  };
}
